import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class ResponseReader {

    constructor() { }

    read(r, o?) {
        /**
         * r for response with the form { error: boolean, message: strig, data: object }
         * o for optional return if error, null will be returned by default
         */
        if (r.hasOwnProperty('error')
            && r.hasOwnProperty('message')) {

            if (r.error) {
                console.error(r.message);
                return o ? o : null;
            } else {
                if (r.hasOwnProperty('data')) {
                    return r.data;
                } else {
                    console.warn('No se encontró la propiedad \'data\' en la respuesta del API');
                    return o ? o : null;
                }
            }

        } else {
            console.warn('No se obtuvo la respuesta esperada del API');
        }

    }

}